module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon12.png?2b51200c";